// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownItalicExtended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-italic.svg?react';
import { createIcons } from '../../Icon';
const MarkdownItalicIcon = /* @__PURE__ */ createIcons('MarkdownItalic', {
    extended: MarkdownItalicExtended
});
MarkdownItalicIcon.supportedTypes = [
    'extended'
];
MarkdownItalicIcon.category = 'markdown';
export default MarkdownItalicIcon;
